import { render, staticRenderFns } from "./Trivia.vue?vue&type=template&id=efd7353e&scoped=true"
import script from "./Trivia.vue?vue&type=script&lang=js"
export * from "./Trivia.vue?vue&type=script&lang=js"
import style0 from "./Trivia.vue?vue&type=style&index=0&id=efd7353e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd7353e",
  null
  
)

export default component.exports